"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsChartColorStrategy = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var executionResultHelper_1 = require("../_util/executionResultHelper");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var PointsChartColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(PointsChartColorStrategy, _super);
    function PointsChartColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PointsChartColorStrategy.prototype.singleMeasureColorMapping = function (colorPalette, colorMapping, dv) {
        var measureGroup = executionResultHelper_1.findMeasureGroupInDimensions(dv.meta().dimensions());
        var measureHeaderItem = measureGroup.items[0];
        var measureColorMapping = sdk_ui_vis_commons_1.getColorFromMapping(measureHeaderItem, colorMapping, dv);
        var color = sdk_ui_vis_commons_1.isValidMappedColor(measureColorMapping, colorPalette)
            ? measureColorMapping
            : { type: "guid", value: colorPalette[0].guid };
        return [
            {
                headerItem: measureHeaderItem,
                color: color,
            },
        ];
    };
    PointsChartColorStrategy.prototype.createSingleColorPalette = function (colorPalette, colorAssignment, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute) {
        var length = viewByAttribute ? viewByAttribute.items.length : 1;
        var color = sdk_model_1.isColorFromPalette(colorAssignment[0].color)
            ? sdk_ui_vis_commons_1.getColorByGuid(colorPalette, colorAssignment[0].color.value, 0)
            : colorAssignment[0].color.value;
        var colorString = sdk_ui_vis_commons_1.getRgbStringFromRGB(color);
        return Array(length).fill(colorString);
    };
    return PointsChartColorStrategy;
}(sdk_ui_vis_commons_1.AttributeColorStrategy));
exports.PointsChartColorStrategy = PointsChartColorStrategy;
//# sourceMappingURL=pointsChart.js.map